module.exports = __webpack_public_path__ + "img/orng_2.9394268c.jpg";